// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SimpleCard_wrapper__3lRvZ"};